import { render, staticRenderFns } from "./collection-detail.vue?vue&type=template&id=7ecf6466&scoped=true&"
import script from "./collection-detail.vue?vue&type=script&lang=js&"
export * from "./collection-detail.vue?vue&type=script&lang=js&"
import style0 from "./collection-detail.vue?vue&type=style&index=0&id=7ecf6466&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ecf6466",
  null
  
)

component.options.__file = "collection-detail.vue"
export default component.exports